export const BRAND_PATH_NAME = 'brands';

const getBrandLinkFromSlug = (slug: string): string => {
  return `/${BRAND_PATH_NAME}/${slug}`;
};

export default getBrandLinkFromSlug;
